import { Button, Stack, TextField } from '@mui/material';

import { useNavigateParams } from '../../../hooks/useNavigateParams';
import SystemTabs from '../../../ui/SystemTabs';
import Checkbox from '../../form/Checkbox';
import Input from '../../form/Input';
import InputFloat from '../../form/InputNumber';
import SelectEmpresa from '../../form/SelectEmpresa';

import { formatarNumero3Digitos } from '../../../utils/masks';
function Form({
    dados,
    setDados,
    handleSubmit,
    caminhoVoltar,
    OptionsEmpresa,
    editando,
    carregando,
    salvando,
    falhaCarregamento,
}) {
    const navigate = useNavigateParams();

    function handleChange(event) {
        const { name, value, type, checked } = event.target;

        setDados((anterior) => {
            const valor = type === 'checkbox' ? checked : value;

            const deveUsarMaiusculo = ['codigo', 'quadra', 'lote'].includes(name);

            return {
                ...anterior,

                [name]: deveUsarMaiusculo ? String(valor).toUpperCase() : valor,
            };
        });
    }

    function submit(event) {
        event.preventDefault();

        handleSubmit(dados);
    }

    const tabDados = (
        <Stack spacing={2}>
            <TextField
                size="small"
                name="diaVencimento"
                label="Dia de vencimento"
                value={dados?.diaVencimento ?? ''}
                onChange={handleChange}
                helperText="Informe de 1 a 31. Em meses mais curtos, usa o último dia. Vazio utiliza o padrão da empresa."
                title="Informe de 1 a 31. Em meses mais curtos, usa o último dia. Vazio utiliza o padrão da empresa."
                inputProps={{ inputMode: 'numeric' }}
                sx={{ width: 300, maxWidth: '100%' }}
            />
            <Stack direction="row" spacing={2} useFlexGap flexWrap="wrap">
                <SelectEmpresa
                    name="empresaId"
                    text="Empresa"
                    options={OptionsEmpresa}
                    handleOnChange={handleChange}
                    value={dados?.empresaId || ''}
                    disabled={editando}
                    required
                    notOptNull={false}
                />

                <Input
                    text="Código"
                    type="text"
                    name="codigo"
                    placeholder="Ex.: Q01-L05"
                    title="Código interno da unidade condominial"
                    handleOnChange={handleChange}
                    value={dados?.codigo || ''}
                    maxlength={50}
                    required
                />

                <Input
                    text="Descrição"
                    type="text"
                    name="descricao"
                    placeholder="Descrição da unidade"
                    title="Descrição para identificação do lote"
                    inputWidth="350px"
                    handleOnChange={handleChange}
                    value={dados?.descricao || ''}
                    maxlength={255}
                    required
                />
            </Stack>

            <Stack direction="row" spacing={2} useFlexGap flexWrap="wrap">
                <Checkbox
                    title="Indica que a unidade está localizada no interior da PORTARIA do condomínio"
                    text="Portaria"
                    name="portaria"
                    handleOnChange={handleChange}
                    value={dados?.portaria}
                    checked={Boolean(dados?.portaria)}
                />
                <Input
                    text="Quadra"
                    type="text"
                    name="quadra"
                    placeholder="Ex.: A"
                    handleOnChange={handleChange}
                    value={dados?.quadra || ''}
                    maxlength={20}
                    required
                />

                <Input
                    text="Lote"
                    type="text"
                    name="lote"
                    placeholder="Ex.: 05"
                    handleOnChange={handleChange}
                    value={dados?.lote || ''}
                    maxlength={20}
                    required
                />

                <Input
                    text="area"
                    type="text"
                    name="area"
                    placeholder="Área (m²)"
                    inputWidth="100px"
                    title={`Área (m²)`}
                    handleOnChange={handleChange}
                    value={dados?.area}
                />
            </Stack>

            <Checkbox
                title="Indica que a unidade pode ser utilizada nas rotinas do condomínio"
                text="Ativa"
                name="ativo"
                handleOnChange={handleChange}
                value={dados?.ativo}
                checked={Boolean(dados?.ativo)}
            />

            <TextField
                name="observacao"
                label="Observação"
                value={dados?.observacao || ''}
                onChange={handleChange}
                multiline
                minRows={3}
                fullWidth
            />
        </Stack>
    );

    const tabsConfig = [
        {
            key: 'dados',
            label: 'Unidade',
            title: 'Dados da unidade condominial',
            panel: tabDados,
        },
    ];

    return (
        <form onSubmit={submit} autoComplete="off">
            <h1>{editando ? 'EDIÇÃO DA UNIDADE CONDOMINIAL' : 'CADASTRO DA UNIDADE CONDOMINIAL'}</h1>

            <SystemTabs tabs={tabsConfig} initialKey="dados" />

            <Stack
                direction="row"
                spacing={1}
                sx={{
                    mt: 2,
                }}
            >
                <Button
                    variant="contained"
                    color="secondary"
                    type="button"
                    disabled={salvando}
                    onClick={() => navigate(caminhoVoltar)}
                >
                    Voltar
                </Button>

                <Button type="submit" variant="contained" color="success" disabled={carregando || salvando || falhaCarregamento}>
                    {salvando ? 'Salvando...' : editando ? 'Atualizar' : 'Cadastrar'}
                </Button>
            </Stack>
        </form>
    );
}

export default Form;
